import { MultiSelect } from '@lmc/ui-kit'
import styled from 'styled-components'

export const MainContainer = styled.div`
  max-width: 1128px;
  margin: 24px auto;
  padding: 0 24px 48px;
  display: flex;
  flex-direction: column;
  gap: 24px;
  width: 100%;
  box-sizing: border-box;
`

export const ContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`

export const Filters = styled.div`
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  justify-content: space-between;
  align-items: flex-start;
`

export const LeftContainer = styled.div`
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
  align-items: flex-start;
  flex: 1;
  min-width: 0;
`

export const RightAlign = styled.div`
  display: flex;
  align-items: center;
  flex-shrink: 0;
`

export const StyledMultiSelect = styled(MultiSelect)`
  min-width: 200px;
`

export const TableScroll = styled.div`
  width: 100%;
  min-width: 0;
  overflow-x: auto;
  border-radius: 20px;
`

export const LoaderWrap = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 320px;
  width: 100%;
`
